// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ProfileAvatarIcon_avatar__1I48R"};